import React, { useEffect, useState } from "react"
import { Modal, ModalHeader, ModalFooter, Button, ModalBody, Label, Input } from "reactstrap"
import { ModalContainerProps } from "./_ModalContainer"

export type SetupGistModalProps = {}

export const SetupGistModal: React.FC<SetupGistModalProps & ModalContainerProps> = ({ closeSelf }) => {
    const [username, setUsername] = useState("")
    const [apiKey, setApiKey] = useState("")

    useEffect(() => {
        setUsername(window.localStorage.getItem('gist-user') ?? '')
        setApiKey(window.localStorage.getItem('gist-api-key') ?? '')
    }, [])

    const handleConfirm = () => {
        window.localStorage.setItem('gist-user', username)
        window.localStorage.setItem('gist-api-key', apiKey)
        closeSelf()
    }

    return (
        <Modal
            isOpen
            fade={false}
            toggle={closeSelf}
            backdrop={"static"}
        >
            <ModalHeader>
                {'Setup gist'}
            </ModalHeader>

            <ModalBody className="p-3 m-0 bg-light">
                <p className="small p-3 bg-white border">
                    {`You can use Github Gist as a very ad-hoc sharing solution.`}
                    {' '}
                    {`Specify the gist username and API token here. All users have to setup their browers with the same credentials.`}
                </p>

                <Label for="username" className="small">
                    {"Gist Username"}
                </Label>
                <Input
                    bsSize='sm'
                    type="text"
                    name="username"
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <Label for="apiKey" className="small mt-3">
                    {"API Key"}
                </Label>
                <Input
                    bsSize='sm'
                    type="text"
                    name="apiKey"
                    id="apiKey"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                />
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                <Button
                    size="sm"
                    onClick={handleConfirm}
                    color={"primary"}
                    disabled={!username || !apiKey}
                >
                    {"Confirm"}
                </Button>

                <Button
                    outline
                    size="sm"
                    onClick={closeSelf}
                    title={"Cancel (esc)"}
                >
                    {"Cancel"}
                </Button>
            </ModalFooter>
        </Modal >
    )
}
